import { encodeMessage } from '@modules/build-hub-comment/utils/comment-parser';
import type {
    CommentSubmitPayload,
    Entity,
} from '@modules/build-hub-comment/types';

export function useCommentContract() {
    function encode(
        message: string,
        entities: Entity[],
        context?: { documentId?: string | null }
    ): CommentSubmitPayload {
        const encoded = encodeMessage(message, entities);
        return {
            v: 1,
            message: encoded,
            entities,
            context,
        };
    }

    function decode(payload: CommentSubmitPayload): {
        message: string;
        entities: Entity[];
    } {
        const decoded = encodeMessage(payload.message, payload.entities);
        return { message: decoded, entities: payload.entities };
    }

    return { encode, decode };
}
